import React, { useCallback, useMemo, useState } from "react";
import { createUseStyles } from "react-jss";
import { useHistory } from "react-router-dom";
import { theme } from "$utils/theme/bataillog";
import useDebouncedEffect from "$hooks/useDebounceEffect";
import { VerifyUsers } from "$services/Coordinators.service";
import Text from "$components/Text";
import ConnexionLayout from "./ConnexionLayout";
import ConnexionForm from "./ConnexionForm";
import useAuth from "$hooks/useAuth";
import { EMAIL_MATCH_REGEX } from "./constants";
import { publicIconPath } from "$utils/constants";

function Connexion() {
  const classes = useStyles();
  const history = useHistory();
  const { login, modifyPasswordAndLogin } = useAuth();
  const [error, setError] = useState<string>("");
  const [email, setEmail] = useState<string>("");
  const [userId, setUserId] = useState<string>("");
  const [load, setLoad] = useState<boolean>(false);
  const [statusAccount, setStatusAccount] = useState<
    "unknown" | "new" | "exist"
  >("unknown");
  const emailMatch = useMemo(() => EMAIL_MATCH_REGEX, []);

  const onSubmit = async (data: any) => {
    setLoad(true);
    if (statusAccount === "exist") {
      await login(data.email, data.password, data.stay_connected)
        .then(() => {
          setError("");
          history.push("/");
        })
        .catch((reason: any) => {
          if (reason.response) {
            setError(
              reason.response.data?.error_description ===
                "Wrong email or password."
                ? "Le mot de passe est incorrect. Veuillez le modifier."
                : reason.response.data?.error_description ??
                    reason.response.data
            );
          }
        });
    } else {
      await modifyPasswordAndLogin(
        userId,
        data.email,
        data.newPasssword,
        data.stay_connected
      )
        .then(() => {
          setError("");
          history.push("/");
        })
        .catch((reason: any) => {
          // eslint-disable-next-line no-console
          console.log(reason);
        });
    }
    setLoad(false);
  };

  const handleNewUser = useCallback(
    async (emailUser: string) => {
      if (!emailUser) return setStatusAccount("unknown");
      if (emailUser && !emailUser.match(emailMatch)) {
        return setStatusAccount("unknown");
      }
      try {
        const { newuser, isDisable, auth0Id, error } = await VerifyUsers(
          emailUser
        );
        if (error) {
          setStatusAccount("unknown");
        } else if (isDisable) {
          setStatusAccount("unknown");
        } else if (newuser) {
          setStatusAccount("new");
          setUserId(auth0Id);
        } else {
          setStatusAccount("exist");
        }
        if (!error) return null;
        return setError(error);
      } catch (err: any) {
        return setStatusAccount("unknown");
      }
    },
    [emailMatch]
  );

  useDebouncedEffect(
    () => {
      handleNewUser(email);
    },
    [email],
    4
  );
  const connectionLabel = "Connexion";

  return (
    <ConnexionLayout>
      <img
        alt="ico-batail"
        src={`${publicIconPath}/logo.png`}
        className={classes.iconImg}
      />
      <Text type="h1" className={classes.connexionLabel}>
        {connectionLabel}
      </Text>
      <Text>Bienvenue chez Batail-Log</Text>
      <ConnexionForm
        onSubmit={onSubmit}
        passwordField={statusAccount === "exist"}
        newPasswordFields={statusAccount === "new"}
        stayConnected
        forgottenPassword
        callbackError={error}
        getEmail={setEmail}
        emailMatch={emailMatch}
        disableForm={load}
        setError={setError}
      />
      {/* <Text type="text" className={classes.subscription}>
        Je ne suis pas encore inscrit ?{" "}
        <a
          rel="noreferrer"
          href="https://www.batail-log.com/inscription"
          target="_blank"
          className={classes.newAccountLink}
        >
          <Text type="link" className={classes.newAccount}>
            Demander un compte
          </Text>
        </a>
      </Text> */}
    </ConnexionLayout>
  );
}

const useStyles = createUseStyles(() => ({
  connexionLabel: {
    margin: [18, 0],
    [`@media (max-height: ${theme.media.mobileHeight}px)`]: {
      margin: [5, 0],
    },
  },
  newAccount: {
    color: theme.color.blueLight,
  },
  newAccountLink: {
    textDecorationColor: theme.color.blueLight,
  },
  subscription: {
    fontSize: 13,
  },
  errorField: {
    minHeight: 20,
    color: theme.color.red,
    fontSize: 12,
  },
  iconImg: {
    height: 100,
    marginLeft: 18,
  },
}));

export default Connexion;
